import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import AdminHeader from "./../layouts/AdminHeader";
import AdminSider from "./../layouts/AdminSider";
import { useToast } from "@chakra-ui/react";
import convertToBase64 from "../../helper/convert";
import BASE_URL from "../baseUrl/baseUrl";
import { Select } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
} from "react-country-state-city";

import "react-country-state-city/dist/react-country-state-city.css";
const AdminagentSaysEdit = (props) => {
  const { Option } = Select;
  const navigate = useNavigate();
  const params = useParams();
  const toast = useToast();
  const [icon, setIcon] = useState();
  const [stateid, setstateid] = useState(0);
  const [countryid, setCountryid] = useState(0);
  const [url, setUrl] = useState();
  const [flag, setFlag] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [lastname, setlastname] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState();
  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [telephoneNo, setTelephoneNo] = useState("");
  const [chatId, setChatId] = useState("");
  const [telegramId, setTelegramId] = useState("");
  const [weChatId, setWeChatId] = useState("");
  const [lineId, setLineId] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [realEstateType, setRealEstateType] = useState("");
  const [userId, setUserId] = useState("");
  const [toggleLineId, setToggleLineId] = useState(true);
  const [toggleWechatId, setToggleWechatId] = useState(true);
  const [toggleAgentWhatsApp, setToggleAgentWhatsApp] = useState(true);
  const [toggleTelegram, settoggleTelegram] = useState(true);
  const [countryCode, setCountryCode] = useState("");
  const [state, setState] = useState('');

  const loca = useLocation();
  const handleTypesChange = (value) => {
    setRealEstateType(value);
  };
  useEffect(() => {
    setlastname(loca?.state?.lastname);
    setCity(loca?.state?.city);
    setCountry(loca?.state?.country);
    setName(loca?.state?.name);
    setArea(loca?.state?.area);
    setTelephoneNo(loca.state?.tel);
    setCountryCode(loca.state?.countryCode);
    setCountryid(loca.state?.countryId);
    setLineId(loca.state?.lineId)
    setChatId(loca.state?.weChatId)
    setTelegramId(loca.state?.telegramId)
    setLineId(loca.state?.lineId)
    setWeChatId(loca?.state?.whatsappId)
    setState(loca?.state?.state)
    const line = checkFieldsForNonNumeric(loca.state?.lineId);
    const whatsapp = checkFieldsForNonNumeric(loca.state?.whatsappId);
    const agentwhatsapp = checkFieldsForNonNumeric(loca.state?.weChatId);
    const telegram = checkFieldsForNonNumeric(loca.state?.telegramId);
    setToggleLineId(!line);
    setToggleAgentWhatsApp(!agentwhatsapp);
    setToggleWechatId(!whatsapp);
    settoggleTelegram(!telegram)
    setRealEstateType(loca.state?.realEstateType);
    setUserId(loca.state?.user);
    setUrl(loca.state?.imageUrl);
  }, [params.id || loca]);

  const onCancel = () => {
    navigate("/admin/agentsays");
  };
  const postData = () => {
    if (name === "") {
      toast({
        title: "Error",
        description: "Name field is empty!!!",
        status: "error",
        duration: 2000,
        variant: "left-accent",
        position: "top-right",
        isClosable: true,
      });
      return false;
    }
    const formData = new FormData();
    formData.append("name", name);
    formData.append("lastname", lastname);
    formData.append("city", city || "");
    formData.append("tel", telephoneNo);
    formData.append("countryCode", countryCode);
    formData.append("chatId", chatId);
    formData.append("weChatId", weChatId);
    formData.append("lineId", lineId);
    formData.append("telegramId", telegramId);
    formData.append("area", area);
    formData.append("image", icon);
    formData.append("country", country);
    formData.append("state", state || "");
    formData.append("countryId", countryid || "1");
    realEstateType?.forEach((item, index) => {
      formData.append(`realEstateType[${index}]`, item);
    });
    formData.append("user", userId);
    setFlag(true);
    axios
      .put(`${BASE_URL}/agent/update-agent/${params.id}`, formData)
      .then((res) => {
        setFlag(false);
        toast({
          title: "Success",
          description: "It has been updated successfully.",
          status: "success",
          duration: 2000,
          variant: "left-accent",
          position: "top-right",
          isClosable: true,
        });
        navigate("/admin/agentsays");
      })
      .catch((err) => {
        setFlag(false);
        setError(true);
        setErrorMsg(err);
      });
  };

  const onUpload = async (e) => {
    const base64 = await convertToBase64(e.target.files[0]);
    setUrl(base64);
    setIcon(e.target.files[0]);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleCountryChange = (e) => {
    setCountryCode(e.target.value);
  };
  const checkFieldsForNonNumeric = (fields) => {

    if (typeof fields !== "string") {
      return false;
    }

    const hasNonNumeric = /\D/.test(fields);

    return hasNonNumeric;
  };
  const countrycode = [
    "+966", // Saudi Arabia
    "+1", // United States
    "+44", // United Kingdom
    "+92", // Pakistan
    "+91", // India
    "+33", // France
    "+49", // Germany
    "+81", // Japan
    "+86", // China
    "+61", // Australia
    "+34", // Spain
    "+39", // Italy
    "+7", // Russia
    "+82", // South Korea
    "+52", // Mexico
    "+55", // Brazil
    "+971", // United Arab Emirates
    "+968", // Oman
    "+20", // Egypt
    "+27", // South Africa
    "+30", // Greece
    "+31", // Netherlands
    "+32", // Belgium
    "+46", // Sweden
    "+47", // Norway
    "+48", // Poland
    "+54", // Argentina
    "+56", // Chile
    "+57", // Colombia
    "+58", // Venezuela
    "+60", // Malaysia
    "+63", // Philippines
    "+64", // New Zealand
    "+65", // Singapore
    "+66", // Thailand
    "+81", // Japan
    "+82", // South Korea
    "+84", // Vietnam
    "+86", // China
    "+90", // Turkey
    "+91", // India
    "+92", // Pakistan
    "+93", // Afghanistan
    "+94", // Sri Lanka
    "+95", // Myanmar
    "+98", // Iran
    "+212", // Morocco
    "+213", // Algeria
    "+216", // Tunisia
    "+218", // Libya
    "+220", // Gambia
    "+221", // Senegal
    "+222", // Mauritania
    "+223", // Mali
    "+224", // Guinea
    "+225", // Ivory Coast
    "+226", // Burkina Faso
    "+227", // Niger
    "+228", // Togo
    "+229", // Benin
    "+230", // Mauritius
    "+231", // Liberia
    "+232", // Sierra Leone
    "+233", // Ghana
    "+234", // Nigeria
    "+235", // Chad
    "+236", // Central African Republic
    "+237", // Cameroon
    "+238", // Cape Verde
    "+239", // Sao Tome and Principe
    "+240", // Equatorial Guinea
    "+241", // Gabon
    "+242", // Republic of the Congo
    "+243", // Democratic Republic of the Congo
    "+244", // Angola
    "+245", // Guinea-Bissau
    "+246", // British Indian Ocean Territory
    "+247", // Ascension Island
    "+248", // Seychelles
    "+249", // Sudan
    "+250", // Rwanda
    "+251", // Ethiopia
    "+252", // Somalia
    "+253", // Djibouti
    "+254", // Kenya
    "+255", // Tanzania
    "+256", // Uganda
    "+257", // Burundi
    "+258", // Mozambique
    "+260", // Zambia
    "+261", // Madagascar
    "+262", // Reunion
    "+263", // Zimbabwe
    "+264", // Namibia
    "+265", // Malawi
    "+266", // Lesotho
    "+267", // Botswana
    "+268", // Eswatini
    "+269", // Comoros
  ];

  return (
    <div>
      <Helmet>
        <title>Buy Home For Less | Agent Says</title>
        <meta name="description" content="#" />
      </Helmet>
      <AdminHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      <div style={{ display: "flex" }}>
        <AdminSider
          url={props.url}
          isOpen={sidebarOpen}
          onStateChange={(state) => setSidebarOpen(state.isOpen)}
          collapsed={collapsed}
          toggleCollapsed={toggleCollapsed}
        />
        <div style={{ flex: 1, padding: "20px" }}>
          <div className="text-center" style={{ margin: "20px" }}>
            <h2> Agent Says Edit</h2>
          </div>
          <div
            className="acr-user-content"
            style={{
              display: "flex",
              justifyContent: "center",
              marginLeft: sidebarOpen ? "20vh" : "0",
            }}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              style={{
                width: "70%",
                padding: "2%",
              }}
            >
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control form-control-light"
                  placeholder="Name"
                  name="name"
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  value={lastname}
                  onChange={(e) => setlastname(e.target.value)}
                  className="form-control form-control-light"
                  placeholder="Last Name"
                  name="lastname"
                />
              </div>
                  <div className="form-group mt-3">
                <h6 className="my-2">Country </h6>
                  <CountrySelect
                    onChange={(e) => {
                      console.log(e);
                      setCountryid(e.id);
                      setCountry(e?.name)
                    }}
                    
                    placeHolder={country}
                  />
                   <h6 className="my-2">Province/State </h6>
                  <StateSelect
                     countryid={countryid}
                    onChange={(e) => {
                      setstateid(e.id);
                      setState(e?.name)
                    }}
                    placeHolder={state}
                  />
                  <h6 className="my-2">Amphor/Khet </h6>
                  <CitySelect
                    countryid={countryid}
                    stateid={stateid}
                    onChange={(e) => {
                      setCity(e?.name)
                    }}
                    placeHolder={city}
                  />
                </div>
              <div className="form-group mt-3 position-relative">
                <label>Tel Number</label>
                <div className="input-group">
                  <PhoneInput
                      country={"th"} // Set default country code, e.g., "cn" for China
                      value={telephoneNo}
                      name="whatsappId"
                      onChange={(e) => setTelephoneNo(e)}
                      inputStyle={{ width: "100%" }} // Set the input width to match other form fields
                      placeholder="Whatsapp Id" // Placeholder text for the input field
                    />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>WhatsApp ID/Username</label>
                  {toggleAgentWhatsApp ? (
                    <PhoneInput
                      country={"th"} // Set default country code, e.g., "cn" for China
                      value={weChatId}
                      name="whatsappId"
                      onChange={(phone) => setWeChatId(phone)}
                      inputStyle={{ width: "100%" }} // Set the input width to match other form fields
                      placeholder="Whatsapp Id" // Placeholder text for the input field
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control w-100"
                      style={{ width: "100%" }}
                      placeholder="whatsapp Id"
                      value={weChatId}
                      onChange={(e) => setWeChatId(e.target.value)}
                    />
                  )}
                  <button
                    onClick={() => setToggleAgentWhatsApp((prev) => !prev)}
                    className={` ${
                      toggleAgentWhatsApp
                        ? "border-2 bg-[#519fff] border-white rounded-lg p-2 text-white"
                        : "bg-[white] text-black rounded-lg border-2 border-color-black mt-1 p-2"
                    }`}
                  >
                    {toggleAgentWhatsApp
                      ? "Switch to Text Input"
                      : "Switch to Phone Input"}
                  </button>
                </div>
                <div className="col-md-3">
                  <label>WeChat ID / Username</label>
                  <div className="input-group">
                    {toggleWechatId ? (
                      <PhoneInput
                        country={"th"} // Set default country code, e.g., "cn" for China
                        value={chatId}
                        name="whatsappId"
                        onChange={(phone) => setChatId(phone)}
                        inputStyle={{ width: "100%" }} // Set the input width to match other form fields
                        placeholder="We chat Id" // Placeholder text for the input field
                      />
                    ) : (
                      <input
                        type="text"
                        className="form-control w-100"
                        style={{ width: "100%" }}
                        placeholder="We chat Id"
                        value={chatId}
                        onChange={(e) => setChatId(e.target.value)}
                      />
                    )}
                    <button
                      onClick={() => setToggleWechatId((prev) => !prev)}
                      className={` ${
                        toggleWechatId
                          ? "border-2 bg-[#519fff] border-white rounded-lg p-2 text-white"
                          : "bg-[white] text-black rounded-lg border-2 border-color-black mt-1 p-2"
                      }`}
                    >
                      {toggleWechatId
                        ? "Switch to Text Input"
                        : "Switch to Phone Input"}
                    </button>
                  </div>
                </div>

                <div className="col-md-3">
                  <label>Line Id / Username</label>
                  {toggleLineId ? (
                    <PhoneInput
                      country={"th"} // Set default country code, e.g., "cn" for China
                      value={lineId}
                      name="Line Id"
                      onChange={(phone) => setLineId(phone)}
                      inputStyle={{ width: "100%" }} // Set the input width to match other form fields
                      placeholder="Line Id" // Placeholder text for the input field
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control w-100"
                      style={{ width: "100%" }}
                      placeholder="Line Id"
                      value={lineId}
                      onChange={(e) => setLineId(e.target.value)}
                    />
                  )}
                  <button
                    onClick={() => setToggleLineId((prev) => !prev)}
                    className={` ${
                      toggleLineId
                        ? "border-2 bg-[#519fff] border-white rounded-lg p-2 text-white"
                        : "bg-[white] text-black rounded-lg border-2 border-color-black mt-1 p-2"
                    }`}
                  >
                    {toggleLineId
                      ? "Switch to Text Input"
                      : "Switch to Phone Input"}
                  </button>
                </div>
                <div className="col-md-3 ">
                  <label>Telegram ID / Username</label>
                  {toggleTelegram ? (
                    <PhoneInput
                      country={"th"} // Set default country code, e.g., "cn" for China
                      value={telegramId}
                      name="telegramId"
                      onChange={(phone) => setTelegramId(phone)}
                      inputStyle={{ width: "100%" }} // Set the input width to match other form fields
                      placeholder="Telegram ID" // Placeholder text for the input field
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control w-100"
                      style={{ width: "100%" }}
                      placeholder="Telegram ID"
                      value={telegramId}
                      onChange={(e) => setTelegramId(e.target.value)}
                    />
                  )}
                  <button
                    onClick={() => settoggleTelegram((prev) => !prev)}
                    className={` ${
                      toggleTelegram
                        ? "border-2 bg-[#519fff] border-white rounded-lg p-2 text-white"
                        : "bg-[white] text-black rounded-lg border-2 border-color-black mt-1 p-2"
                    }`}
                  >
                    {toggleTelegram
                      ? "Switch to Text Input"
                      : "Switch to Phone Input"}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>What area do you want to sell real estate?</label>
                <input
                  type="text"
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                  className="form-control form-control-light"
                  placeholder="area"
                  name="area"
                />
              </div>
              <div className="form-group">
                <label>Type of real estate you're interested in selling:</label>
                <Select
                  mode="multiple"
                  placeholder="Select an option"
                  style={{ width: "100%" }}
                  onChange={handleTypesChange}
                  value={realEstateType}
                >
                  <Option value={"Residential"}>Residential</Option>
                  <Option value={"Commercial"}>Commercial</Option>
                  <Option value={"Villa"}>Villa</Option>
                  <Option value={"Resort"}>Resort</Option>
                  <Option value={"Hotel"}>Hotel</Option>
                  <Option value={"Condo"}>Condo</Option>
                  <Option value={"Appartment"}>Appartment</Option>
                  <Option value={"land"}>Land</Option>
                </Select>
              </div>
              <div className="form-group row">
                <label htmlFor="icon" className="cursor-pointer">
                  Select Image
                </label>
                <input
                  onChange={onUpload}
                  type="file"
                  id="icon"
                  name="icon"
                  style={{ display: "none" }}
                />
                {url && url.slice(0, 7) === "uploads" ? (
                  <img src={`${url}`} alt="Icon" style={{ width: "100px" }} />
                ) : (
                  <img src={url} alt="Icon" style={{ width: "100px" }} />
                )}
              </div>
              <div className="form-group text-right">
                {flag ? (
                  <button type="Submit" disabled className="btn btn-primary">
                    <span className="fa fa-save"></span> Saving...
                  </button>
                ) : (
                  <button
                    type="Submit"
                    onClick={() => postData()}
                    className="btn btn-primary"
                  >
                    <span className="fa fa-save"></span> Save
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => onCancel()}
                >
                  <span className="fa fa-reply"></span> Cancel
                </button>
              </div>
            </form>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            {error ? (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "70%",
                  backgroundColor: "#FF3131",
                  color: "white",
                  padding: "10px 20px 10px 20px",
                  borderRadius: "5px",
                  alignItems: "center",
                }}
              >
                <span>{error ? `${errorMsg}` : ""}</span>
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    border: "white 2px solid",
                    borderRadius: "30px",
                    width: "40px",
                    backgroundColor: "#FF3131",
                    height: "40px",
                  }}
                  onClick={() => {
                    setError(false);
                  }}
                >
                  <p
                    style={{
                      color: "white",
                      alignItems: "center",
                      marginTop: "3px",
                    }}
                  >
                    x
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminagentSaysEdit;
